import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/clinics',
  title: 'Clínicas',
  endpoint: '/app/company?type=clinic',
  breadcrumbs: [],
}
